<template>
  <v-container
    id="alerts"
    fluid
    tag="section"
  >
    <base-material-card class="px-5 py-3">
      <template v-slot:heading>
        <div class="headline mt-3 font-weight-light">
          {{ $t('notificacoes') }}
        </div>
      </template>
    </base-material-card>
  </v-container>
</template>

<script>
  export default {
    name: 'DashboardNotifications',

    data: () => ({
    }),

    /*     computed: {
      parsedDirection () {

      },
    },

    methods: {
      randomColor () {

      },
    }, */
  }
</script>
